module.exports = __webpack_public_path__ + "static/media/banner.e84e5858.jpeg";